

















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'product-applications-modal',
    components: {
        Spinner,
    },
    computed: {
        ...mapState('productApplications', ['activeProductApplicationLoading', 'activeProductApplication']),
    },
})
export default class ProductApplicationsModal extends Vue {
    //
    private activeProductApplication!: any;
    private activeProductApplicationLoading!: any;

    private searchQuery: string = '';

    onSaveProductApplication() {
        this.activeProductApplication.slug = this.string_to_slug(this.activeProductApplication.name);
        if (this.activeProductApplication.id == 0) {
            this.$store.dispatch('productApplications/postOne', {
                vm: this,
                data: this.activeProductApplication,
            });
        } else {
            this.$store.dispatch('productApplications/putOne', {
                vm: this,
                data: this.activeProductApplication,
            });
        }
        // this.activeProductApplication.id = 0;
        // this.activeProductApplication.slug = '';
        // this.activeProductApplication.name = '';
    }

    string_to_slug(str: string) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
        var to = 'aaaaaeeeeiiiioooouuuunc------';

        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str
            .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return str;
    }
}
